import * as React from 'react';

import { scienceBlue } from '../abstracts/colours';

export interface IconProps {
  fill?: string;
}

const UnfoldMore: React.SFC<IconProps> = ({ fill = scienceBlue }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 12 24">
    <g fill="none" fillRule="evenodd" transform="translate(-6 -9)">
      <g>
        <path d="M0 0L16 0 16 16 0 16z" opacity=".87" transform="rotate(90 8 12)" />
        <path
          fill={fill}
          fillRule="nonzero"
          d="M10.794 2.235c-.274-.313-.715-.313-.989 0L5.163 7.549c-.217.25-.217.652 0 .902l4.642 5.314c.274.313.715.313.989 0s.274-.819 0-1.132L6.75 7.997 10.8 3.36c.268-.307.268-.819-.006-1.126z"
          transform="rotate(90 8 12)"
        />
      </g>
      <g>
        <path d="M0 0L16 0 16 16 0 16z" opacity=".87" transform="matrix(0 -1 -1 0 20 38)" />
        <path
          fill={fill}
          fillRule="nonzero"
          d="M10.794 2.235c-.274-.313-.715-.313-.989 0L5.163 7.549c-.217.25-.217.652 0 .902l4.642 5.314c.274.313.715.313.989 0s.274-.819 0-1.132L6.75 7.997 10.8 3.36c.268-.307.268-.819-.006-1.126z"
          transform="matrix(0 -1 -1 0 20 38)"
        />
      </g>
    </g>
  </svg>
);

export default UnfoldMore;
